import CharterMarketplace from "@/pages/CharterMarketplace";
export default function Fleet() { return <CharterMarketplace />; }
